<template>
  <section class="app-main">
    <router-view v-slot="{ Component, route }" :key="route.path" v-if="appStore.routerActive">
      <transition name="fade-transform" mode="out-in">
        <keep-alive :include="cachedViews">
          <component :is="Component" :key="route.path"/>
        </keep-alive>
      </transition>
    </router-view>
  </section>
</template>

<script setup>
import useAppStore from '@/store/modules/app'
import useTagsViewStore from '@/store/modules/tagsView'

const appStore = useAppStore();
const tagsViewStore = useTagsViewStore()
const route = useRoute()
tagsViewStore.addCachedView(route)
const cachedViews = computed(() => {
    return tagsViewStore.cachedViews
})
</script>

<style lang="scss" scoped>
.app-main {
  width: 100%;
  position: relative;
  overflow-y: auto;
}

.hasTagsView {
  .app-main {
    height: calc(100% - 84px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
    height: 100% !important;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 17px;
  }
}
</style>